// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_header__nILKm {
  display: flex;
  padding: 1rem 2rem;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px;
}
@media screen and (min-width: 480px) {
  .styles_header__nILKm {
    justify-content: space-between;
  }
}
@media screen and (min-width: 768px) {
  .styles_header__nILKm {
    padding: 2rem 3rem;
  }
}

.styles_storageActionsWrapper__nNeIj {
  display: flex;
  flex: 1 1;
  width: 100%;
}
.styles_storageActionsWrapper__nNeIj .styles_pulse__GkIHI {
  animation: styles_pulse-animation__YG5jR 2s infinite;
  background-color: red;
  opacity: 0.8;
}
@keyframes styles_pulse-animation__YG5jR {
  0% {
    box-shadow: 0 0 0 0px rgba(255, 0, 0, 0.2);
  }
  100% {
    box-shadow: 0 0 0 16px rgba(255, 0, 0, 0);
  }
}
.styles_storageActionsWrapper__nNeIj button {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  border: none;
  background-color: transparent;
  cursor: pointer;
  font-size: 0.8rem;
  color: #000;
  font-weight: 500;
}
.styles_storageActionsWrapper__nNeIj button img {
  padding: 0.5rem;
  border-radius: 999px;
  background-color: #6ba7a8;
  width: 20px;
  height: 20px;
}
.styles_storageActionsWrapper__nNeIj .styles_manageLocalStorage__nDdKl {
  position: fixed;
  padding: 1rem;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
}
.styles_storageActionsWrapper__nNeIj .styles_manageLocalStorage__nDdKl .styles_manageLocalStorageCard__9qKuC {
  width: 100%;
  max-width: 500px;
  background-color: #fff;
  border-radius: 10px;
  padding: 20px;
}
.styles_storageActionsWrapper__nNeIj .styles_manageLocalStorage__nDdKl .styles_manageLocalStorageCard__9qKuC .styles_manageLocalStorageCardHeader__Uq7yb {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.styles_storageActionsWrapper__nNeIj .styles_manageLocalStorage__nDdKl .styles_manageLocalStorageCard__9qKuC .styles_manageLocalStorageCardHeader__Uq7yb .styles_manageLocalStorageCardHeaderActions__OW7jE {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}
.styles_storageActionsWrapper__nNeIj .styles_manageLocalStorage__nDdKl .styles_manageLocalStorageCard__9qKuC .styles_manageLocalStorageCardHeader__Uq7yb .styles_manageLocalStorageCardHeaderActions__OW7jE .styles_button__utUou {
  padding: 0 8px 0 0;
  border-radius: 999px;
  border: 1px solid #606060;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background-color: transparent;
  cursor: pointer;
  font-size: 0.8rem;
  color: #000;
  font-weight: 500;
  transition: color 0.3s ease;
}
.styles_storageActionsWrapper__nNeIj .styles_manageLocalStorage__nDdKl .styles_manageLocalStorageCard__9qKuC .styles_manageLocalStorageCardHeader__Uq7yb .styles_manageLocalStorageCardHeaderActions__OW7jE .styles_button__utUou span {
  width: 100%;
  overflow: hidden;
  transition: width 0.3s ease;
  text-wrap: nowrap;
}
.styles_storageActionsWrapper__nNeIj .styles_manageLocalStorage__nDdKl .styles_manageLocalStorageCard__9qKuC .styles_manageLocalStorageCardHeader__Uq7yb .styles_manageLocalStorageCardHeaderActions__OW7jE .styles_button__utUou:hover {
  color: #606060;
}
.styles_storageActionsWrapper__nNeIj .styles_manageLocalStorage__nDdKl .styles_manageLocalStorageCard__9qKuC .styles_manageLocalStorageCardHeader__Uq7yb .styles_manageLocalStorageCardHeaderActions__OW7jE .styles_button__utUou:hover span {
  width: 100%;
}
.styles_storageActionsWrapper__nNeIj .styles_manageLocalStorage__nDdKl .styles_manageLocalStorageCard__9qKuC .styles_manageLocalStorageCardHeader__Uq7yb .styles_manageLocalStorageCardHeaderActions__OW7jE .styles_button__utUou:hover img {
  opacity: 0.5;
}
.styles_storageActionsWrapper__nNeIj .styles_manageLocalStorage__nDdKl .styles_manageLocalStorageCard__9qKuC .styles_manageLocalStorageCardHeader__Uq7yb .styles_manageLocalStorageCardHeaderActions__OW7jE .styles_button__utUou img {
  transition: opacity 0.3s ease;
  opacity: 1;
}
.styles_storageActionsWrapper__nNeIj .styles_manageLocalStorage__nDdKl .styles_manageLocalStorageCard__9qKuC .styles_manageLocalStorageCardHeader__Uq7yb .styles_manageLocalStorageCardHeaderActions__OW7jE .styles_buttonX__HXIC4 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 36px;
  height: 36px;
  background-color: transparent;
  border-radius: 999px;
  border: 1px solid #606060;
  cursor: pointer;
  color: #000;
  font-size: 1rem;
  font-weight: 500;
  line-height: 1;
  transition: background-color 0.3s ease, color 0.3s ease;
}
.styles_storageActionsWrapper__nNeIj .styles_manageLocalStorage__nDdKl .styles_manageLocalStorageCard__9qKuC .styles_manageLocalStorageCardHeader__Uq7yb .styles_manageLocalStorageCardHeaderActions__OW7jE .styles_buttonX__HXIC4:hover {
  background-color: #000;
  color: #fff;
}
.styles_storageActionsWrapper__nNeIj .styles_manageLocalStorage__nDdKl .styles_manageLocalStorageCard__9qKuC .styles_manageLocalStorageContent__lrVXD {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 2rem;
  max-height: 300px;
  overflow-y: auto;
}
.styles_storageActionsWrapper__nNeIj .styles_manageLocalStorage__nDdKl .styles_manageLocalStorageCard__9qKuC .styles_manageLocalStorageContent__lrVXD .styles_manageLocalStorageItem__M4eeD {
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  padding: 1rem;
  border-radius: 10px;
  background-color: #f0f0f0;
  font-size: 0.7rem;
}
.styles_storageActionsWrapper__nNeIj .styles_manageLocalStorage__nDdKl .styles_manageLocalStorageCard__9qKuC .styles_manageLocalStorageContent__lrVXD .styles_manageLocalStorageItem__M4eeD div:first-child {
  width: 25%;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.styles_storageActionsWrapper__nNeIj .styles_manageLocalStorage__nDdKl .styles_manageLocalStorageCard__9qKuC .styles_manageLocalStorageContent__lrVXD .styles_manageLocalStorageItem__M4eeD div:nth-child(2) {
  width: 50%;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.styles_storageActionsWrapper__nNeIj .styles_manageLocalStorage__nDdKl .styles_manageLocalStorageCard__9qKuC .styles_manageLocalStorageContent__lrVXD .styles_manageLocalStorageItem__M4eeD div:nth-child(3) {
  width: 25%;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.styles_storageActionsWrapper__nNeIj .styles_manageLocalStorage__nDdKl .styles_manageLocalStorageCard__9qKuC .styles_manageLocalStorageContent__lrVXD .styles_manageLocalStorageItem__M4eeD div:nth-child(4) {
  width: 25%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.styles_storageActionsWrapper__nNeIj .styles_manageLocalStorage__nDdKl .styles_manageLocalStorageCard__9qKuC .styles_manageLocalStorageContent__lrVXD .styles_manageLocalStorageItem__M4eeD div:nth-child(4) button {
  background-color: transparent;
  border: none;
  cursor: pointer;
  font-size: 0.7rem;
  font-weight: 500;
  color: #000;
  transition: color 0.3s ease;
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 1;
}
.styles_storageActionsWrapper__nNeIj .styles_manageLocalStorage__nDdKl .styles_manageLocalStorageCard__9qKuC .styles_manageLocalStorageContent__lrVXD .styles_manageLocalStorageItem__M4eeD div:nth-child(4) button:hover {
  color: #666;
}
.styles_storageActionsWrapper__nNeIj .styles_manageLocalStorage__nDdKl .styles_manageLocalStorageCard__9qKuC .styles_manageLocalStorageContent__lrVXD .styles_manageLocalStorageItem__M4eeD div:nth-child(4) button:last-child {
  color: red;
}`, "",{"version":3,"sources":["webpack://./src/components/layout/header/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,uFAAA;AACF;AAEE;EATF;IAUI,8BAAA;EACF;AACF;AACE;EAbF;IAcI,kBAAA;EAEF;AACF;;AACA;EACE,aAAA;EACA,SAAA;EACA,WAAA;AAEF;AAAE;EACE,oDAAA;EACA,qBAAA;EACA,YAAA;AAEJ;AACE;EACE;IACE,0CAAA;EACJ;EACE;IACE,yCAAA;EACJ;AACF;AAEE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,6BAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;AAAJ;AAEI;EACE,eAAA;EACA,oBAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;AAAN;AAIE;EACE,eAAA;EACA,aAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAFJ;AAII;EACE,WAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;EACA,aAAA;AAFN;AAIM;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAFR;AAIQ;EACE,oBAAA;EACA,mBAAA;EACA,WAAA;AAFV;AAIU;EACE,kBAAA;EACA,oBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,6BAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;EACA,2BAAA;AAFZ;AAGY;EACE,WAAA;EACA,gBAAA;EACA,2BAAA;EACA,iBAAA;AADd;AAIY;EACE,cAAA;AAFd;AAGc;EACE,WAAA;AADhB;AAGc;EACE,YAAA;AADhB;AAKY;EACE,6BAAA;EACA,UAAA;AAHd;AAOU;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,6BAAA;EACA,oBAAA;EACA,yBAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,uDAAA;AALZ;AAMY;EACE,sBAAA;EACA,WAAA;AAJd;AAUM;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AARR;AAUQ;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,iBAAA;AARV;AAUU;EACE,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AARZ;AAWU;EACE,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AATZ;AAYU;EACE,UAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAVZ;AAaU;EACE,UAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AAXZ;AAaY;EACE,6BAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,2BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;AAXd;AAYc;EACE,WAAA;AAVhB;AAac;EACE,UAAA;AAXhB","sourcesContent":[".header {\n  display: flex;\n  padding: 1rem 2rem;\n  justify-content: center;\n  align-items: center;\n  box-sizing: border-box;\n  box-shadow: rgba(0, 0, 0, 0.1) 0px 10px 15px -3px,\n    rgba(0, 0, 0, 0.05) 0px 4px 6px -2px;\n\n  @media screen and (min-width: 480px) {\n    justify-content: space-between;\n  }\n\n  @media screen and (min-width: 768px) {\n    padding: 2rem 3rem;\n  }\n}\n\n.storageActionsWrapper {\n  display: flex;\n  flex: 1;\n  width: 100%;\n\n  .pulse {\n    animation: pulse-animation 2s infinite;\n    background-color: red;\n    opacity: 0.8;\n  }\n  \n  @keyframes pulse-animation {\n    0% {\n      box-shadow: 0 0 0 0px rgba(255, 0, 0, 0.2);\n    }\n    100% {\n      box-shadow: 0 0 0 16px rgba(255, 0, 0, 0);\n    }\n  }\n\n  button {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    border: none;\n    background-color: transparent;\n    cursor: pointer;\n    font-size: 0.8rem;\n    color: #000;\n    font-weight: 500;\n\n    img {\n      padding: 0.5rem;\n      border-radius: 999px;\n      background-color: #6ba7a8;\n      width: 20px;\n      height: 20px;\n    }\n  }\n\n  .manageLocalStorage {\n    position: fixed;\n    padding: 1rem;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.5);\n    z-index: 1000;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    .manageLocalStorageCard {\n      width: 100%;\n      max-width: 500px;\n      background-color: #fff;\n      border-radius: 10px;\n      padding: 20px;\n\n      .manageLocalStorageCardHeader {\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n\n        .manageLocalStorageCardHeaderActions {\n          display: inline-flex;\n          align-items: center;\n          gap: 0.5rem;\n\n          .button {\n            padding: 0 8px 0 0;\n            border-radius: 999px;\n            border: 1px solid #606060;\n            display: flex;\n            align-items: center;\n            gap: 0.5rem;\n            background-color: transparent;\n            cursor: pointer;\n            font-size: 0.8rem;\n            color: #000;\n            font-weight: 500;\n            transition: color 0.3s ease;\n            span {\n              width: 100%;\n              overflow: hidden;\n              transition: width 0.3s ease;\n              text-wrap: nowrap;\n            }\n\n            &:hover {\n              color: #606060;\n              span {\n                width: 100%;\n              }\n              img {\n                opacity: 0.5;\n              }\n            }\n\n            img {\n              transition: opacity 0.3s ease;\n              opacity: 1;\n            }\n          }\n\n          .buttonX {\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            width: 36px;\n            height: 36px;\n            background-color: transparent;\n            border-radius: 999px;\n            border: 1px solid #606060;\n            cursor: pointer;\n            color: #000;\n            font-size: 1rem;\n            font-weight: 500;\n            line-height: 1;\n            transition: background-color 0.3s ease, color 0.3s ease;\n            &:hover {\n              background-color: #000;\n              color: #fff;\n            }\n          }\n        }\n      }\n\n      .manageLocalStorageContent {\n        display: flex;\n        flex-direction: column;\n        gap: 1rem;\n        margin-top: 2rem;\n        max-height: 300px;\n        overflow-y: auto;\n\n        .manageLocalStorageItem {\n          display: flex;\n          flex-direction: row;\n          gap: 0.5rem;\n          padding: 1rem;\n          border-radius: 10px;\n          background-color: #f0f0f0;\n          font-size: 0.7rem;\n\n          div:first-child {\n            width: 25%;\n            text-align: left;\n            overflow: hidden;\n            text-overflow: ellipsis;\n            white-space: nowrap;\n          }\n\n          div:nth-child(2) {\n            width: 50%;\n            text-align: left;\n            overflow: hidden;\n            text-overflow: ellipsis;\n            white-space: nowrap;\n          }\n\n          div:nth-child(3) {\n            width: 25%;\n            text-align: center;\n            overflow: hidden;\n            text-overflow: ellipsis;\n            white-space: nowrap;\n          }\n\n          div:nth-child(4) {\n            width: 25%;\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            overflow: hidden;\n            text-overflow: ellipsis;\n            white-space: nowrap;\n\n            button {\n              background-color: transparent;\n              border: none;\n              cursor: pointer;\n              font-size: 0.7rem;\n              font-weight: 500;\n              color: #000;\n              transition: color 0.3s ease;\n              display: flex;\n              justify-content: center;\n              align-items: center;\n              line-height: 1;\n              &:hover {\n                color: #666;\n              }\n\n              &:last-child {\n                color: red;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `styles_header__nILKm`,
	"storageActionsWrapper": `styles_storageActionsWrapper__nNeIj`,
	"pulse": `styles_pulse__GkIHI`,
	"pulse-animation": `styles_pulse-animation__YG5jR`,
	"manageLocalStorage": `styles_manageLocalStorage__nDdKl`,
	"manageLocalStorageCard": `styles_manageLocalStorageCard__9qKuC`,
	"manageLocalStorageCardHeader": `styles_manageLocalStorageCardHeader__Uq7yb`,
	"manageLocalStorageCardHeaderActions": `styles_manageLocalStorageCardHeaderActions__OW7jE`,
	"button": `styles_button__utUou`,
	"buttonX": `styles_buttonX__HXIC4`,
	"manageLocalStorageContent": `styles_manageLocalStorageContent__lrVXD`,
	"manageLocalStorageItem": `styles_manageLocalStorageItem__M4eeD`
};
export default ___CSS_LOADER_EXPORT___;
